var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid grid__base", class: _vm.rootClasses }, [
    _c("div", { staticClass: "image-slider--container grid--container" }, [
      _vm.isInteractive
        ? _c(
            "div",
            [
              _c("swiper-slider", {
                attrs: { items: _vm.images },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _c(
                          "figure",
                          { staticClass: "image-slider--image-wrapper" },
                          [
                            _c(
                              "base-image",
                              _vm._b(
                                { staticClass: "image-slider--image" },
                                "base-image",
                                props.image,
                                false
                              )
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        : _c(
            "figure",
            { staticClass: "image-slider--image-wrapper" },
            [
              _c(
                "base-image",
                _vm._b(
                  { staticClass: "image-slider--image" },
                  "base-image",
                  _vm.images[0].image,
                  false
                )
              )
            ],
            1
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3615d290", { render: render, staticRenderFns: staticRenderFns })
  }
}